var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status != null)?_c('v-sheet',{staticClass:"d-flex align-center justify-center completion-label rounded-circle mx-2 mt-2",attrs:{"width":"72","height":"72"}},[(_vm.status == 'Completed')?_c('v-icon',{attrs:{"color":"#C5B4E3","large":""}},[_vm._v("mdi-check")]):_c('div',[_vm._v(_vm._s(_vm.status))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }